import { fileURLToPath } from "node:url";
import { dirname, join, resolve } from "node:path";
import { existsSync } from "node:fs";
import { homedir } from "node:os";

/**
 * Package root = the installed @carrierllc/mcp directory.
 * dist/index.js lives at <root>/dist/index.js, so root is one level up.
 * The bundled `plugin/` and `templates/` dirs are shipped alongside `dist`.
 */
export function packageRoot(): string {
  const here = dirname(fileURLToPath(import.meta.url));
  // When bundled, `here` is <root>/dist. During ts-node/source runs it is <root>/src/lib.
  for (const candidate of [resolve(here, ".."), resolve(here, "..", "..")]) {
    if (existsSync(join(candidate, "plugin")) && existsSync(join(candidate, "templates"))) {
      return candidate;
    }
  }
  return resolve(here, "..");
}

/** Marketplace root — passed to `claude plugin marketplace add`. */
export function pluginSourceDir(): string {
  return join(packageRoot(), "plugin");
}

/** Plugin root (the `carrier/` subdir of the marketplace) — used for the file-copy
 *  fallback and reading the plugin manifest. Claude Code rejects a marketplace that
 *  points a plugin at its own root (`source: "."`), so the plugin lives one level in. */
export function pluginManifestDir(): string {
  return join(packageRoot(), "plugin", "carrier");
}

export function storefrontTemplateDir(): string {
  return join(packageRoot(), "templates", "storefront");
}

/** ~/.claude — Claude Code's user config home. */
export function claudeHome(): string {
  return process.env.CLAUDE_CONFIG_DIR
    ? resolve(process.env.CLAUDE_CONFIG_DIR)
    : join(homedir(), ".claude");
}

export function claudePluginsDir(): string {
  return join(claudeHome(), "plugins");
}

export function installedPluginDir(): string {
  return join(claudePluginsDir(), "carrier");
}
